// @ts-strict-ignore
import { createContext, useContext } from 'react'

export function debounce(func: any, timeout = 300) {
  let timer: NodeJS.Timeout
  return (...args: any) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, timeout)
  }
}

/**
 * timeout
 *
 * Used when we want to wait for a tracking event to resolve,
 * and we don't want to block what happens after
 *
 * @param {Promise} promise - promise which should resolve
 * @param {number} [ms] - (optional) number of ms before promise resolves
 * @returns {Promise} - which will resolve after a timeout
 */
export function timeout(promise: Promise<any>, ms: number = 50): Promise<any> {
  return Promise.race([willResolve(ms), promise])
}

function willResolve(ms: number): Promise<any> {
  return new Promise((resolve) => {
    setTimeout(resolve, ms)
  })
}

const ComponentTrackingContext = createContext(() => {
  // eslint-disable-next-line no-console
  console.warn("You shouldn't reach here")
})

export const useComponentTracking = () => {
  return useContext(ComponentTrackingContext)
}
